// extracted by mini-css-extract-plugin
module.exports = {"embed_video":"video_embed_video__36nZi","embed_video_wrapper":"video_embed_video_wrapper__3L6ue","video":"video_video__25QHf"};